const styles = {
  button: {
    backgroundColor: "black",
    color: "white",
    outline: "none",
    fontSize: 18,
    padding: "12px 0px",
  },
  card: { position: "relative" },
  cardFooter: { padding: "10px", fontSize: 10 },
  homeScreenReminder: {
    height: "500px",
    width: "500px",
    borderRadius: "25px",
    padding: "20px",
    paddingTop: "50px",
    backgroundColor: "#efefe9",
  },
};

export default styles;
